import {styled} from "@mui/material";
import List from "@mui/material/List";
import CircularProgress from "@mui/material/CircularProgress";
import Chip from "@mui/material/Chip";

/** Matches the initial document-template selector width used by Conflicts and Policies. */
export const EMBEDDED_TEMPLATE_PANEL_WIDTH = 450;

export const EmbeddedTemplatePanelContent = styled("div")(({ theme }) => ({
  boxSizing: "border-box",
  flexShrink: 0,
  minWidth: 0,
  width: EMBEDDED_TEMPLATE_PANEL_WIDTH,
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
}));

export const EmbeddedTemplatePanelHeader = styled("div")(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  gap: theme.spacing(1),
  justifyContent: "space-between",
  minWidth: 0,
  padding: theme.spacing(1),
  paddingBottom: 0,
  width: "100%",
}));

export const TemplateList = styled(List)(
  ({ theme }) => ({
    maxHeight: "25rem",
    minWidth: "20rem",
    overflowX: "hidden",
    overflowY: "auto",
    [theme.breakpoints.down("md")]: {
      maxHeight: "min(45vh, 18rem)",
      minWidth: 0,
      width: "100%",
    },
  }));

export const TemplateLoader = styled(CircularProgress)(
  ({ theme }) => ({
    color: theme.palette.primary.main,
    margin: theme.spacing(2),
  }));

export const FeeScheduleTagChip = styled(Chip)(
  ({ theme }) => ({
    color: "#777",
    marginRight: theme.spacing(0.25),
  }));
